export { default as Component } from "./StatusTracker.svelte";
export const modes = ["static"];
